import axios from "axios";
import { useState, useEffect } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Toast/ToastContext"; // Import useToast hook
import "../../assets/css/Loader.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Expense() {
  const toast = useToast(); // Use the toast hook

  const [loading, setLoading] = useState(true); // Initialize as true to show spinner on first load
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  // Open and close modal functions
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const navigate = useNavigate();

  const handleClickExpenseType = () => {
    navigate("/expense-item");
  };

  // get method
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // "YYYY-MM-DD"
    setAddData((prevData) => ({ ...prevData, date: formattedDate }));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    // setIsLoading(true);
    try {
      const response = await axios.get(`${ApiUrl}/Api/expense.php`);
      console.log("Response from server:", response.data);

      if (response.data && response.data.data) {
        const reversedData = response.data.data.reverse(); // Reverse the array

        setTimeout(() => {
          setLoading(false);
        }, 1000);

        setResponseData(reversedData); // Set reversed data
      } else {
        console.error("Unexpected data structure:", response.data);
        setResponseData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
      setResponseData([]);
    } finally {
      setTimeout(() => {
        // setLoading(false);
        setIsLoading(false);
      }, 400);
    }
  };

  // map to getting data

  const [typeGetting, setTypeGetting] = useState([]);

  useEffect(() => {
    fetchProductType();
  }, []); // Added empty dependency array to prevent infinite loop

  const fetchProductType = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/expense_type.php`);
      console.log("Response from product type:", response);
      // Make sure we're setting an array to typeGetting
      setTypeGetting(response.data?.data || []); // Assuming the API returns data in a 'data' property
    } catch (error) {
      console.log("getting data problem", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
      setTypeGetting([]); // Set to empty array on error
    }
  };

  // Format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // add method
  const [addData, setAddData] = useState({
    type: "",
    date: "",
    description: "",
    amount: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  // Add user
  const handlesubmit = async (e) => {
    e.preventDefault();

    // Validate required fields before proceeding
    const errors = {};
    if (!addData.type) errors.type = "Type is required";
    if (!addData.date) errors.date = "Date is required";
    if (!addData.amount) errors.amount = "amount is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return; // stop submission if errors exist
    } else {
      setFormErrors({}); // clear errors
    }

    try {
      setLoading(true);
      const formData = {
        type: addData.type,
        date: addData.date,
        description: addData.description,
        amount: addData.amount,
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };
      const response = await axios.post(`${ApiUrl}/Api/expense.php`, formData);
      console.log("Submit data:", response);
      setShowModal(false);

      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.success("Added successfully!", 3000, "topRight");

      setAddData({
        type: "",
        date: "",
        description: "",
        amount: "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      });
      fetchData();
      toast.success("Added successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to Added data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // update method
  const closeUpdateModal = () => setUpdateModal(false);

  const [updateData, setUpdateData] = useState({
    type: "",
    date: "",
    description: "",
    amount: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (id, data) => {
    setUpdateId(id);
    console.log("The data to update", data);
    setUpdateModal(true);
    setUpdateData({
      type: data.type,
      date: data.date,
      description: data.description,
      amount: data.amount,
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  // Update user
  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        type: updateData.type,
        date: updateData.date,
        description: updateData.description,
        amount: updateData.amount,
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };

      console.log("The update submit data", formData);
      const response = await axios.put(
        `${ApiUrl}/Api/expense.php/${updateid}`,
        formData
      );
      console.log("Response for update", response);
      setUpdateModal(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      // toast.success("Update successfully!");
      toast.success("Update successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to Update data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // delete method
  const [deleteShowModals, setDeleteShowModals] = useState(false); // Delete modal
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  // Delete confirmation modal
  const handleOpenModal = (id, type) => {
    setdeleteid(id);
    setdeletename(type);
    setDeleteShowModals(true);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/expense.php/${getdeleteid}`
      );

      console.log("Delete data ", response);
      // toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      toast.success("Deleted successfully!", 3000, "topRight");

      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete data", 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // Pagination functions
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.type && item.type.toLowerCase().includes(searchLower)) ||
      (item.date && item.date.toLowerCase().includes(searchLower)) ||
      (item.description && item.description.toString().includes(searchLower)) ||
      (item.amount && item.amount.toLowerCase().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Export Functions
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const printContent = `
    <html>
      <head>
        <title>Expenses Report</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h1 { color: #333; text-align: center; margin-bottom: 30px; }
          table { border-collapse: collapse; width: 100%; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
          th { background-color: #f2f2f2; font-weight: bold; }
          tr:nth-child(even) { background-color: #f9f9f9; }
          @media print { body { margin: 0; } }
        </style>
      </head>
      <body>
        <h1>Expenses Report</h1>
          <p style="margin-top: 20px; text-align: center; color: #666;">
          Total Records: ${
            currentItems.length
          } | Generated on: ${new Date().toLocaleString()}
        </p>
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Type</th>
              <th>Date</th>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${
              currentItems && currentItems.length > 0
                ? currentItems
                    .map(
                      (item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.type || ""}</td>
                  <td>${
                    item.date ? new Date(item.date).toLocaleDateString() : ""
                  }</td>
                  <td>${item.description || ""}</td>
                  <td>${item.amount || ""}</td>
                </tr>
              `
                    )
                    .join("")
                : `<tr><td colspan="5" style="text-align:center;">No data available</td></tr>`
            }
          </tbody>
        </table>
      
      </body>
    </html>
  `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
    toast.success("Print dialog opened!", 2000, "topRight");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Expense Report", 14, 10);

    autoTable(doc, {
      head: [["S.No", "Type", "Date", "Description", "Amount"]],
      body: filteredData.map((item, index) => [
        index + 1,
        item.type,
        formatDate(item.date),
        item.description,
        item.amount,
      ]),
      startY: 20,
    });

    doc.save("expense_report.pdf");
    toast.success("PDF exported successfully!", 3000, "topRight");
  };

  const exportCSV = () => {
    const headers = ["S.No,Type,Date,Description,Amount"];
    const rows = filteredData.map((item, index) =>
      [
        index + 1,
        item.type,
        formatDate(item.date),
        item.description,
        item.amount,
      ].join(",")
    );

    const csvContent = [headers, ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "expense_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("CSV exported successfully!", 3000, "topRight");
  };

  const exportExcel = () => {
    const wsData = [
      ["S.No", "Type", "Date", "Description", "Amount"],
      ...filteredData.map((item, index) => [
        index + 1,
        item.type,
        formatDate(item.date),
        item.description,
        item.amount,
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Expenses");
    XLSX.writeFile(wb, "expense_report.xlsx");
    toast.success("Excel exported successfully!", 3000, "topRight");
  };

  const copyToClipboard = () => {
    try {
      const headers = ["S.No", "Type", "Date", "Description", "Amount"];

      const rows = (filteredData || []).map((item, index) => [
        index + 1,
        item.type || "",
        formatDate(item.date) || "",
        item.description || "",
        item.amount || "",
      ]);

      // Quote fields and join with tabs/newlines
      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success("Table data copied to clipboard!", 3000, "topRight");
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        toast.success("Table data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  return (
    <>
      {/* {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )} */}

      <div className="container-fluid py-3 mb-5">
        {/* Add Customer Button */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <h6 className="card-title m-2">Expense</h6>
            <button
              className="btn btn-primary btn-sm rounded-3 ms-2"
              onClick={openModal}
            >
              Add <span className="ms-2">+</span>
            </button>
          </div>

          <button
            className="btn btn-primary btn-sm rounded-3 me-3"
            onClick={handleClickExpenseType}
          >
            Expense Type <span className="ms-2">+</span>
          </button>
        </div>

        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Center - Export/Action buttons */}
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="card tableCard p-2">
              <div className="table-container">
                {isLoading ? (
                  <div className="text-center p-4">Loading...</div>
                ) : (
                  <table className="table table-layout-fixed w-100">
                    <thead className="bg-light">
                      <tr>
                        <th>S.No</th>
                        <th>Expense Types</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Amount (₹)</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems && currentItems.length > 0 ? (
                        currentItems.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.type}</td>
                            <td>{formatDate(item.date)}</td>
                            <td>{item.description}</td>
                            <td>{item.amount}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => handleUpdate(item.id, item)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>

                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleOpenModal(item.id, item.type)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">&laquo;&laquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>

                      {renderPageNumbers()}

                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">&raquo;&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Add Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addCustomerModalLabel"
              >
                Add Expense
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="UserId" className="form-label">
                        Ex-Type Name
                      </label>

                      <select
                        className={`form-select ${
                          formErrors.type ? "is-invalid" : ""
                        }`}
                        id="type"
                        value={addData.type}
                        onChange={(e) =>
                          setAddData({ ...addData, type: e.target.value })
                        }
                      >
                        <option value="" disabled>
                          Select Type
                        </option>
                        {Array.isArray(typeGetting) &&
                          typeGetting.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.expense_type}
                            </option>
                          ))}
                      </select>
                      {formErrors.type && (
                        <div className="invalid-feedback">
                          {formErrors.type}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="Date" className="form-label">
                        Date
                      </label>
                      <input
                        type="date"
                        className={`form-control ${
                          formErrors.date ? "is-invalid" : ""
                        }`}
                        id="date"
                        value={addData.date}
                        onChange={(e) =>
                          setAddData({ ...addData, date: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="Description" className="form-label">
                    Description
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="description"
                    placeholder="Enter Description"
                    value={addData.description}
                    onChange={(e) =>
                      setAddData({ ...addData, description: e.target.value })
                    }
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="Amount" className="form-label">
                    Amount (₹)
                  </label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className={`form-control ${
                      formErrors.amount ? "is-invalid" : ""
                    }`}
                    id="amount"
                    placeholder="Enter Amount"
                    value={addData.amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and at most one decimal point with up to 2 decimals
                      if (/^\d*\.?\d{0,2}$/.test(value)) {
                        setAddData({ ...addData, amount: value });
                      }
                    }}
                    required
                  />
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    onClick={handlesubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Update Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{ display: updateModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="updateCustomerModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateCustomerModalLabel"
              >
                Update Expenses
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="UserId" className="form-label">
                        Ex-Type Name
                      </label>

                      <select
                        className="form-select"
                        id="type"
                        value={updateData.type}
                        onChange={(e) =>
                          setUpdateData({ ...updateData, type: e.target.value })
                        }
                      >
                        <option value="" disabled>
                          Select Type
                        </option>
                        {Array.isArray(typeGetting) &&
                          typeGetting.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.expense_type}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="Date" className="form-label">
                        Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="date"
                        value={updateData.date}
                        onChange={(e) =>
                          setUpdateData({ ...updateData, date: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="Description" className="form-label">
                    Description
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="description"
                    placeholder="Enter Description"
                    value={updateData.description}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="Amount" className="form-label">
                    Amount
                  </label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    id="amount"
                    placeholder="Enter Amount"
                    value={updateData.amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and optionally one dot with up to 2 decimal places
                      if (/^\d*\.?\d{0,2}$/.test(value)) {
                        setUpdateData({ ...updateData, amount: value });
                      }
                    }}
                    required
                  />
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    onClick={handleupdatesubmit}
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                  }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>

              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary">({getdeletename})</span>?
              </h6>

              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal backdrop */}
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default Expense;
